import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import ManageEvents from "./ManageEvents";
import EventProfile from "./EventProfile/EventProfile";
import DashboardLayout from "../../containers/DashboardLayout";
import Container from "../../components/Container";
import ProfileDetails from "./EventProfile/ProfileDetails";
import ManageEventSidebar from "../../containers/Sidebar/ManageEventSidebar";
import ManageEventsItems from "../../containers/Sidebar/ManageEventSidebarNav";
import { dashboardColors, theme } from "../../themes/Theme";
import { toggleBodyScroll } from "../../services/util";
import Reports from "./Reports/Reports";
import { getOrganiserEventCurrencies, getOrganiserReports } from "../../revampCRUD/accountLevelReports.crud";
import getSymbolFromCurrency from "currency-symbol-map"; // ADD THIS IMPORT
import { getWhichCountrySymbolForDollar } from "./Reports/AccountLevelReportConstant";
import ReportsCurrencyDropdown from "./Reports/ReportsCurrencyDropdown";
import customToast from "../../components/common/basic/Toast";
import ReportsEmptyState from "./Reports/ReportsEmptyState";

const EventDashboardPage = (props) => {
    const location = useLocation();
    const [expandedSection, setExpandedSection] = useState(null);

    // Determine which heading to show based on the current path
    const matchedItem = ManageEventsItems.find(item => item.path === location.pathname);
    const pageHeading = matchedItem?.label || "";
    const currentPath = location?.pathname;
    const isManageEventsPage = true

    // Overlay for mobile sidebar
    const isSidebarVisible = expandedSection === true;

    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    const handleCurrencyChange = (selectedOption) => {
        setSelectedCurrency(selectedOption);
    };

    const fetchCurrencies = async () => {
        setIsLoading(true);
        try {
            const response = await getOrganiserEventCurrencies();
            if (response?.data?.currencies) {
                const mappedOptions = response?.data?.currencies.map((currency) => {
                    const currencyCode = currency?.currency_name;
                    const symbol = getSymbolFromCurrency(currencyCode);
                    const countryPrefix = getWhichCountrySymbolForDollar(currencyCode);
                    const fullSymbol = countryPrefix + (symbol || '');

                    return {
                        value: currency?.currency_id,
                        label: `${currencyCode} (${fullSymbol})`,
                        currency_name: currencyCode,
                        currency_id: currency?.currency_id,
                        symbol: fullSymbol,
                        event_count: currency?.event_count
                    };
                });

                setCurrencyOptions(mappedOptions);

                if (mappedOptions?.length > 0) {
                    setSelectedCurrency(mappedOptions[0]);
                }
            }
        } catch (error) {
            customToast.error(error?.response?.data?.error || 'Something went wrong');
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
    

        fetchCurrencies();
    }, []);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            toggleBodyScroll(expandedSection);
            if (!expandedSection) {
                toggleBodyScroll(false);
            }
        }
    }, [expandedSection]);

    return (
        <DashboardLayout
            props={props}
            setExpandedSection={setExpandedSection}
            expandedSection={expandedSection}
            isManageEventsPage={isManageEventsPage}
        >
            {/* Sidebar and overlay are rendered above the DashboardLayout's children */}
            {/* Sidebar */}



            {/* Overlay for mobile */}
            {isSidebarVisible && (
                <div
                    className="event-dashboard-overlay"
                    onClick={() => setExpandedSection(false)}
                />
            )}

            <Container className="manage_events_container">
                <div className="event-dashboard-flex">

                    <div
                        className={`event-dashboard-sidebar manage_events_container${isSidebarVisible ? " sidebar-visible" : ""}`}
                    >
                        <ManageEventSidebar
                            setExpandedSection={setExpandedSection}
                            expandedSection={expandedSection}
                        />
                    </div>
                    {/* Main content */}
                    <div className={`event-dashboard-main-content${isSidebarVisible ? " sidebar-open" : ""}`}>
                        {currentPath === "/reports" ? <div className=" d-flex justify-content-between align-items-center  "> <div className="page-heading">{pageHeading}</div> <div className="d-flex richtext-gap-3 align-items-center report-heading-margin-bottom"> <span className="report-currency-label">Currency</span>  <div>   
                        <ReportsCurrencyDropdown
                            options={currencyOptions}
                            value={selectedCurrency}
                            onChange={handleCurrencyChange}
                            isLoading={isLoading}
                            placeholder="Select"
                            width="110px"
                        />
                       </div></div> </div> : <div className="page-heading">{pageHeading}</div>}
                        <Switch>
                            {ManageEventsItems.map(({ path }, idx) => {
                                if ((path === "/reports" && selectedCurrency)) {
                                    return (
                                        <Route
                                            exact
                                            path={path}
                                            render={(routeProps) => (
                                                <Reports
                                                    {...routeProps}
                                                    selectedCurrency={selectedCurrency}
                                                />
                                            )}
                                            key={idx}
                                        />
                                    );
                                }
                                if ((path === "/reports" && !selectedCurrency)) {
                                    return (
                                        <Route
                                            exact
                                            path={path}
                                            render={(routeProps) => (
                                                <ReportsEmptyState
                                                    {...routeProps}
                                                    selectedCurrency={selectedCurrency}
                                                />
                                            )}
                                            key={idx}
                                        />
                                    );
                                }
                                const Component =
                                    path === "/manage-events"
                                        ? ManageEvents
                                        : EventProfile;

                                return <Route exact path={path} component={Component} key={idx} />;
                            })}
                            <Route exact path="/">
                                <Redirect to="/manage-events" />
                            </Route>
                        </Switch>
                    </div>
                </div>
            </Container>

            <style>{`
                .event-dashboard-flex {
                    display: flex;
                    min-height: 100vh;
                }
                .event-dashboard-sidebar {
                    background-color: #fff;
                    border-right: 1px solid #e0e0e0;
                    transition: transform 0.3s ease;
                    position: relative;
                }
                .event-dashboard-main-content {
                    flex: 1;
                    padding: 20px 24px 24px 24px;
                    background-color: #f4f7fd;
                    transition: filter 0.3s;
                }
                .page-heading {
                    font-size: 20px;
                    font-weight: 700;
                    color: ${dashboardColors[theme].primary};
                    margin-bottom: 18px;
                    margin-left: 4px;
                }
                .report-currency-label{
                  font-size: 16px;
                    font-weight: 500;
                    color: ${dashboardColors[theme].primaryTextColor};
                } 
                .report-heading-margin-bottom {
                    margin-bottom: 10px;
                }
                .event-dashboard-overlay {
                    display: none;
                }
                /* Mobile Styles */
                @media (max-width: 768px) {
                    .event-dashboard-sidebar {
                        position: fixed;
                        left: 0;
                        height: 100%;
                        z-index: 1001;
                        transform: translateX(-100%);
                        box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
                    }
                    .event-dashboard-sidebar.sidebar-visible {
                        transform: translateX(0);
                        background-color: #fff;
                    }
                    .event-dashboard-overlay {
                        display: block;
                        position: fixed;
                        top: 64px;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0,0,0,0.35);
                        z-index: 1000;
                        transition: background 0.3s;
                    }
                    .event-dashboard-main-content.sidebar-open {
                        filter: brightness(0.95);
                        pointer-events: none;
                        user-select: none;
                    }
                    .event-dashboard-main-content {
                        padding: 16px;
                    }
                }
            `}</style>
        </DashboardLayout>
    );
};

export default EventDashboardPage;
